/*
Closets
 */

const name = 'Closets'
const id = 'FfSijswm5WNkm5WzDSoS'

export default {
  name,
  id
}
